import React, { Component } from 'react';
import connect from 'Shared/connect';
import Radio from 'Shared/Fields/Radio';
import { translate } from 'Shared/translate';
import * as styles from './base.scss';
class FacetAndOrFilter extends Component {
    constructor(props) {
        super(props);
        this.state = { hasAndFilter: this.props.hasAndFilter };
    }
    onAndOrFilterChange(andOrFilter) {
        const hasAndFilter = andOrFilter === 'and';
        this.setState({ hasAndFilter });
        this.props.onAndOrFilterChange(andOrFilter);
    }
    render() {
        const { fieldName, hasAndFilter, pageIsLoading } = this.props;
        const hasAndFilterOptimistic = pageIsLoading ? this.state.hasAndFilter : hasAndFilter;
        return (React.createElement("div", { className: styles.andOrConditionToggles },
            React.createElement("div", { className: "ui-test-facet-value" },
                React.createElement(Radio, { className: styles.facetValue, name: `facet-and-or-filter-${fieldName}`, checked: hasAndFilterOptimistic === false, onChange: () => this.onAndOrFilterChange('or'), value: "or" },
                    React.createElement("span", { className: styles.andOrFilterText }, translate('/Facets/OrFilter')))),
            React.createElement("div", { className: "ui-test-facet-value" },
                React.createElement(Radio, { className: styles.facetValue, name: `facet-and-or-filter-${fieldName}`, checked: hasAndFilterOptimistic === true, onChange: () => this.onAndOrFilterChange('and'), value: "and" },
                    React.createElement("span", { className: styles.andOrFilterText }, translate('/Facets/AndFilter'))))));
    }
}
export default connect((state) => ({
    pageIsLoading: state.currentPage.isLoading,
}))(FacetAndOrFilter);
